var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name != 'candidate' && _vm.$route.name != 'receipt' && _vm.$route.name != 'deposit')?_c('theader'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.$route.name != 'receipt')?_c('tfooter'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce0af2bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./_source/javascript/App.vue
// module id = 100
// module chunks = 0